import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Silly content",
  "description": "",
  "published": "2007-01-03T00:00:00.000Z",
  "redirect_from": ["/blog/silly-content/swizec/341"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Looking through websites like youtube these days a person gets frightened by the complete lack of decent videographic content on them. They were originally created to share videos, or at least that's what someone might think, but you'd agree that means music videos, clips from here and there, and sure, there are quite some of those. But there is much too many stupid things people shoot themselves and put online simply because they can.`}</p>
    <p>{`Everyone knows the danger of watching home videos and nobody really likes to watch them, the only thing worse are young film arts students with their crap that's simply unwatchable as they try far too hard to be artistic but produce something that is neither watchable nor meaningful.`}</p>
    <p>{`And then there are good things. Like a video that perfectly describes `}<a parentName="p" {...{
        "href": "http://www.youtube.com/watch?v=EDHIyHtv0E8"
      }}>{`jar opening`}</a>{`, it's silly, yes, but it's also very true and entertaining. Or the video of a man ranting about `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=JdxkVQy7QLM"
      }}>{`Pachelbel's Canon in D`}</a>{`. These are good videos, they are also very legal to be online ... so please people, why aren't there many `}<em parentName="p">{`many`}</em>{` more like this?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      